module.exports = __webpack_public_path__ + "img/symbol_8.19a5fd8a.png";